// @ts-nocheck
import { createStyle } from '@gluestack-style/react';
import { BaseIconVariants } from './Icon';

export const ButtonIcon = createStyle({
  variants: BaseIconVariants,
  color: 'currentColor',
  props: {
    size: 'md',
    fill: 'none',
    stroke: 'currentColor',
  },
});
